export default "__VITE_ASSET__4$0QVrpb__"